import { render, staticRenderFns } from "./formcheckbox1_0.vue?vue&type=template&id=1fc06c4f"
import script from "./formcheckbox1_0.vue?vue&type=script&lang=js"
export * from "./formcheckbox1_0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports